/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Email_TakenInputs */

const en_adm_err_email_taken = /** @type {(inputs: Adm_Err_Email_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A user with this email address already exists.`)
};

const de_adm_err_email_taken = /** @type {(inputs: Adm_Err_Email_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Benutzer mit dieser E-Mail-Adresse existiert bereits.`)
};

/**
* | output |
* | --- |
* | "A user with this email address already exists." |
*
* @param {Adm_Err_Email_TakenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_email_taken = /** @type {((inputs?: Adm_Err_Email_TakenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Email_TakenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_email_taken(inputs)
	return en_adm_err_email_taken(inputs)
});